import React, { useEffect, useState } from 'react';
import ModalFormOffice from '../../components/forms/users/modal.form.office';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListOffice() {
  const [msgGet ,setMsgGet] = useState('');
  const [Office, setOffice] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getOffice()
  }, []);

  const createOffice = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getOffice()
  };

  const getOffice = async()=>{
    const responseOffice = await get('/office/',{})
    if(responseOffice.success){
      setOffice(responseOffice.data);
    }else{
      setMsgGet(responseOffice.message)
    }       
  }

  const editButton = (row) => {
    return (
      <ModalFormOffice
        title="Modificar Sucursal"
        button_text="Editar"
        button_variant="outline-primary"
        officeSelect={row.id}
        callback={() => createOffice()}
      ></ModalFormOffice>
    );
  };

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormOffice
        title="Crear Sucursal"
        button_text="Crear Sucursal"
        button_variant="primary"
        id={null}
        callback={() => createOffice()}
      ></ModalFormOffice>
      <ListTables
        data={Office}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListOffice;
